"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigation = exports.Row = exports.Caption = void 0;
const MonthCaption_js_1 = require("../components/MonthCaption.js");
const Week_js_1 = require("../components/Week.js");
const useDayPicker_js_1 = require("../useDayPicker.js");
/**
 * @ignore
 * @deprecated This component has been renamed. Use `MonthCaption` instead.
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
exports.Caption = MonthCaption_js_1.MonthCaption;
/**
 * @ignore
 * @deprecated This component has been renamed. Use `Week` instead.
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
exports.Row = Week_js_1.Week;
/**
 * @ignore
 * @deprecated This type has been moved to `useDayPicker`.
 * @group Hooks
 */
exports.useNavigation = useDayPicker_js_1.useDayPicker;
